import React from 'react';
import Link from 'next/link';
import Image from 'next/image';

import upscImage from '../assets/images/initiatives/upsc.png';
import bankImage from '../assets/images/initiatives/bank.png';
import biographyImage from '../assets/images/initiatives/biography.png';

import styles from '../styles/our-initiatives.module.scss';

function OurInitiatives() {
  return (
    <div className={styles.wrapper}>
      <h1>Our Initiatives</h1>
      <div className={styles.initiatives}>
        <Link href="https://www.upsciq.com" target="_blank">
          <Image src={upscImage} alt="UPSC IQ" />
        </Link>
        <Link href="https://www.bankiq.in" target="_blank">
          <Image src={bankImage} alt="Bank IQ" />
        </Link>
        <Link href="https://www.biographyiq.com/" target="_blank">
          <Image src={biographyImage} alt="Biography IQ" />
        </Link>
      </div>
    </div>
  );
}

export default OurInitiatives;
